module.exports = __webpack_public_path__ + "genius.5978628f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/Plugins/genius.png
// module id = 3008
// module chunks = 0